import {
  GET_PLC_SAFETY_EVENT_BY_ID,
  GET_PLC_SAFETY_EVENT_BY_ID_SUCCESS,
  GET_PLC_SAFETY_EVENT_BY_ID_ERROR,
} from './actionTypes';

const initialState = {
  errorGetPlcSafetyEventById: '',
  loadingGetPlcSafetyEventById: false,
  event: null,
};

const getEventById = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_SAFETY_EVENT_BY_ID:
      state = { ...state, loadingGetPlcSafetyEventById: true };
      break;
    case GET_PLC_SAFETY_EVENT_BY_ID_SUCCESS:
      state = { ...state, loadingGetPlcSafetyEventById: false, event: action.payload.event };
      break;
    case GET_PLC_SAFETY_EVENT_BY_ID_ERROR:
      state = { ...state, errorGetPlcSafetyEventById: action.payload, loadingGetPlcSafetyEventById: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getEventById;
